import React from 'react';
import { Activities } from '../../types/Back';

export const AllActivities = (
  { name, difficulty, duration, season }: 
  Activities
) => {
  return (
    <div className='activities__container' >
      <p>
        <strong>Nombre de la Actividad: </strong>
        {name}
      </p>
      <p>
        <strong>Dificultad: </strong>
        Nivel - {difficulty}
      </p>
      <p>
        <strong>Duración: </strong>
        {duration} hora(s)
      </p>
      <p>
        <strong>Temporada: </strong>
        {season}
      </p>
    </div>
  )
}
